import { render, staticRenderFns } from "./GridTemplate.vue?vue&type=template&id=0539da0a&scoped=true&"
import script from "./GridTemplate.vue?vue&type=script&lang=ts&"
export * from "./GridTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./GridTemplate.vue?vue&type=style&index=0&id=0539da0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539da0a",
  null
  
)

export default component.exports